import React from "react";
import { Form } from "react-bootstrap";
import "./dashboard copy.css";

/**
 * CardPerks Component
 *
 * Displays partners' marketplace perks on the dashboard highlighting special deals
 * and exclusive offers for roiquant annual plan customers. Provides navigation to
 * the partners marketplace page to view available perks.
 *
 * @returns {JSX.Element} Dashboard card with partners marketplace information and view button
 */
const CardPerks = () => {
  return (
    <>
      <p className="dashboardCardHeader">
        <Form.Select>
          <option>Partners' perks for roiquant customers</option>
        </Form.Select>
      </p>

      <hr />

      <p className="dashboardCardData">Partners marketplace</p>

      <div className="dashboardDivScrollable">
        <p className="dashboardCardText">
          Explore special deals from our global partners, such as free credits,
          free trials, exclusive discounts, and many more valuable perks for
          roiquant customers.
        </p>
      </div>

      <div className="dashboardBottomDiv">
        <div className="dashboardCardButton">
          <a href="/partners-marketplace">
            <button className="glintanimation navbarideachecker">
              View perks
            </button>
          </a>
        </div>

        <br />

        <p className="dashboardMinorText">Available for all customers</p>
      </div>
    </>
  );
};

export default CardPerks;
